// extracted by mini-css-extract-plugin
module.exports = {"input-clear":"style_input-clear__TqynK"};